<script lang="ts">
  import StudioGridScroll from '$lib/components/StudioGridScroll.svelte'
  import { Button, Icon } from '@bond/components'
  import type { PageData } from './$types'
  import PhoneTemplate from '$lib/components/PhoneTemplate.svelte'
  import { HOME_STRINGS } from './strings'
  import Ambassadors from '$lib/components/Ambassadors.svelte'
  import BruceInformation from '$lib/components/BruceInformation.svelte'
  import { utils } from '$lib/utils'

  export let data: PageData
  $: ({ studios, imageUrl, lang, trial, currentCity } = data)
  $: localeRoute = utils.getRoute(lang)
</script>

<section class="title">
  <h1>{HOME_STRINGS[lang].TITLE}</h1>
  <p>{HOME_STRINGS[lang].DESCRIPTION}</p>
  <div class="buttons">
    {#if trial}
      <Button href={localeRoute('trial')} rounded variant="flat" block>
        {HOME_STRINGS[lang].TRIAL_BUTTON}
      </Button>
    {:else}
      <Button href={localeRoute('membership')} rounded variant="flat" block>
        {HOME_STRINGS[lang].JOIN_BUTTON}
      </Button>
    {/if}
    <Button
      href={localeRoute(
        `studios${currentCity?.name ? `/${utils.toSpeakingUrl(currentCity.name)}` : ''}`,
      )}
      rounded
      variant="outlined"
      block
    >
      {HOME_STRINGS[lang].EXPLORE_BUTTON}
    </Button>
  </div>
</section>
<StudioGridScroll {imageUrl} {studios} />
<section class="explore">
  <div class="background"></div>
  <PhoneTemplate>
    <video
      slot="screen"
      autoPlay
      loop
      muted
      playsInline
      width={480}
      height={1040}
      poster="https://res.cloudinary.com/dbo5hzaqa/video/upload/ac_none,c_scale,h_520,q_64,vc_h264,w_240/v1644300945/Videos/explore.jpg"
    >
      <source
        src="https://res.cloudinary.com/dbo5hzaqa/video/upload/ac_none,c_scale,h_1040,q_70,vc_h264,w_480/v1644300945/Videos/explore.mp4"
        type="video/mp4"
      />
    </video>
  </PhoneTemplate>
  <BruceInformation />
</section>
<Ambassadors ambassadors={HOME_STRINGS[lang].AMBASSADORS} />
<section class="why-bruce">
  <h2>{HOME_STRINGS[lang].WHY_BRUCE_TITLE}</h2>
  <ul>
    {#each HOME_STRINGS[lang].WHY_BRUCE_ITEMS as { ICON, TITLE, DESCRIPTION }, index (index)}
      <li>
        <Icon
          icon={ICON}
          backgroundColor="primary"
          color="on-primary"
          rounded
        />
        <div>
          <h3>{TITLE}</h3>
          <p>{DESCRIPTION}</p>
        </div>
      </li>
    {/each}
  </ul>
</section>

<style lang="scss">
  @use '@bond/assets/css/breakpoints';

  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 2em;

    h1 {
      text-align: center;
    }

    p {
      text-align: center;
      max-width: 600px;
      width: calc(100% - 32px);
      margin: 0;
    }

    .buttons {
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      gap: 1em;
      margin-top: 2em;
      width: 100%;

      @media screen and (max-width: breakpoints.$breakpoint-sm) {
        flex-direction: column;
        align-items: center;
        width: calc(100% - 32px);
        margin: 2em 16px 0 16px;
      }
    }
  }

  .explore {
    box-sizing: border-box;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4em;
    width: 100%;
    margin-top: 4em;
    padding-bottom: 2em;
    color: #fff;
    --button-text-color: #fff;
    --button-text-color-rgb: 255, 255, 255;

    @media screen and (max-width: breakpoints.$breakpoint-sm) {
      flex-direction: column;
      align-items: center;
      gap: 1em;
    }

    .background {
      position: absolute;
      left: 0;
      top: 2em;
      height: calc(100% - 2em);
      width: 100%;
      background-color: var(--explore-background);
      z-index: -1;
    }
  }

  .why-bruce {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin: 2em;
    max-width: 1440px;

    h2 {
      font-size: 42px;
    }

    ul {
      display: flex;
      gap: 2em;
      list-style: none;
      margin: 0;
      padding: 0;

      @media screen and (max-width: breakpoints.$breakpoint-sm) {
        flex-direction: column;
      }

      li {
        display: flex;
        gap: 1em;

        h3 {
          font-size: 20px;
          margin: 0;
        }
      }
    }
  }
</style>
